import React from "react";
import {Collapse, Row} from 'antd';
import {CaretRightOutlined} from '@ant-design/icons';
import './TownHouse.less';
import Property from "./Property";

const {Panel} = Collapse;


const TownHouse = (props) => {

	return (
		<div className={'town-house'}>
			<Collapse
				bordered={false}
				defaultActiveKey={['1']}
				expandIcon={({isActive}) => <CaretRightOutlined rotate={isActive ? 90 : 0}/>}
				className="site-collapse-custom-collapse"
			>
				<Panel header="Townhouses" key="1" className="site-collapse-custom-panel">
					<Row gutter={[16, 10]}>
						{props.data.map((property, index) => <Property key={index} data={property} status={props.status} statusChange={props.statusChange} dataType={props.dataType}/>)}
					</Row>
				</Panel>
			</Collapse>
		</div>
	);
};

export default TownHouse;